import { default as ProductCardTitle } from './product-card-title'

export default ProductCardTitle
